import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Box, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { RelatedWorkThumbnail } from '../RelatedWorkThumbnail';
import type { RelatedWork, RelatedWorkEntry } from './utils';

interface RelatedItemsSectionProps {
  additionalInfoData: Record<string, unknown> | null;
  ownerId?: string | null;
  isPublicRoute?: boolean;
}

const isLinkEntry = (item: RelatedWork): item is RelatedWorkEntry =>
  typeof item === 'object' && item !== null && typeof item.catalogItemId === 'string';

export const RelatedItemsSection: React.FC<RelatedItemsSectionProps> = ({
  additionalInfoData,
  ownerId,
  isPublicRoute = false,
}) => {
  const basePath = isPublicRoute ? '/public/object-details' : '/object-details';
  const works = (Array.isArray(additionalInfoData?.relatedWorks)
    ? additionalInfoData?.relatedWorks
    : []) as RelatedWork[];

  if (works.length === 0) return null;

  return (
    <Accordion data-testid="related-items-section">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h3">Related Items</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {works.map((work, idx) => {
            if (!isLinkEntry(work)) {
              return (
                <Typography key={idx} variant="body1">
                  {String(work)}
                </Typography>
              );
            }
            return (
              <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <RelatedWorkThumbnail
                  catalogItemId={work.catalogItemId}
                  title={work.title}
                  ownerId={ownerId}
                />
                <RouterLink
                  to={`${basePath}/${work.catalogItemId}`}
                  style={{ color: 'inherit', textDecoration: 'none' }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {work.title || work.catalogItemId}
                  </Typography>
                </RouterLink>
              </Box>
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
